<template>
  <div class="form-group" :class="currentWidth">
    <label v-if="idLabel">
      {{ idLabel }}
      <span v-if="isMandatory" class="color-red">* </span>
    </label>
    <div v-if="inputType === 'number'">
        <input class="form-control inputAccordionForm" type="number"
              :placeholder="placeholderValue" v-model.number="inputValue"
              :min="minValue" :max="maxValue"/>
    </div>
    <div v-else-if="inputType !== 'date'">
        <input class="form-control inputAccordionForm" :type="inputType"
              :placeholder="placeholderValue" v-model="inputValue"></input>
    </div>
    <div class="formDatePicker" v-else>
      <date-picker v-model="inputValue" :format="$t('common.datepicker_format_date')" :placeholder="placeholderValue"></date-picker>
    </div>
  </div>
</template>
<script>
/* @author TLV 25/06/2020
* @brief Component utilisé pour les champs à remplir pour envoyer un formulaire
*/

import Datepicker from 'vuejs-datepicker'

export default {
  name: 'formWriteGroupLabelInput',
  props: {
    formGroupWidth: {
      type: String,
      default: '6'
    },
    idLabel: {
      type: String
    },
    placeholderValue: {
      type: String
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    value: {
      default: this.inputType === 'text' ? '' : 0
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: Number.MAX_VALUE // 1.7976931348623157e+308
    },
    breakpoint: {
      type: String,
      default: 'sm'
    }
  },
  components: {
    'date-picker': Datepicker
  },
  computed: {
    currentWidth () {
      if (this.breakpoint === 'nan') {
        return `col-${this.formGroupWidth}`
      } else {
        return `col-${this.breakpoint}-${this.formGroupWidth}`
      }
    },
    // pseudo v-model avec le component parent
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// formWriteGroupLabelInput.vue?0309934e